import { Color } from '../../Enum/Color';
import React from 'react';
import { ExclamationTriangleFill, Grid3x3Gap, InfoSquareFill, PatchCheckFill, X } from 'react-bootstrap-icons';

interface Props {
    active: boolean;
    color: Color | null;
}

const ResultIcon: React.FC<Props> = Props => {
    const { active, color } = Props;

    let className: string;
    if (!active) {
        className = 'non-active';
    } else {
        className = null !== color ? color.toLowerCase() : Color.Grey;
    }

    switch (color) {
        case Color.Green:
            return <PatchCheckFill className={className} />;
        case Color.Orange:
            return <ExclamationTriangleFill className={className} />;
        case Color.Red:
            return <X className={`${className} declined`} />;
        case Color.Blue:
            return <InfoSquareFill className={className} />;
        default:
            return <Grid3x3Gap className={className} />;
    }
};

export default ResultIcon;
